import { FileServiceService } from './../../../services/file-service/file-service.service';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import {
    Component,
    Input,
    OnInit,
    ChangeDetectorRef,
    EventEmitter,
    Output
} from '@angular/core';
import { CertificationRequestInterface } from 'src/app/model/certifications/certification-request-interface';
import { take } from 'rxjs/operators';
import { FileInfoInterface } from 'src/app/model/marketplace/file-info-interface';

@Component({
    selector: 'certification-request-overview',
    templateUrl: './certification-request-overview.component.html',
    styleUrls: ['./certification-request-overview.component.css'],
    standalone: false
})
export class CertificationRequestOverviewComponent implements OnInit {
    @Input()
    public certificationRequest: CertificationRequestInterface;

    @Input()
    public isCertifier: boolean;

    @Output() commented = new EventEmitter<string>();
    documentFileInfosById: Map<string, any> = new Map<
        string,
        FileInfoInterface
    >();

    constructor(
        private dialogService: DialogService,
        private fileService: FileServiceService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.setDocumentFileInfos();
    }

    addNewFiles(addedFiles: string[]): void {
        let newFileIds = [];
        if (this.certificationRequest.fileIds) {
            newFileIds = this.certificationRequest.fileIds;
        }
        this.certificationRequest.fileIds = newFileIds.concat(addedFiles);
        this.setDocumentFileInfos();
    }

    private setDocumentFileInfos(): void {
        if (
            this.certificationRequest.fileIds == null ||
            this.certificationRequest.fileIds.length == 0
        ) {
            return;
        }
        this.fileService
            .getMetaDataForFiles(this.certificationRequest.fileIds)
            .pipe(take(1))
            .subscribe((fileInfos) => {
                this.documentFileInfosById = new Map<
                    string,
                    FileInfoInterface
                >();
                for (const fileInfo of fileInfos) {
                    this.documentFileInfosById.set(fileInfo.id, fileInfo);
                }
                this.cd.detectChanges();
            });
    }

    getNameOfDocument(id: string): string {
        if (this.documentFileInfosById && this.documentFileInfosById.has(id)) {
            return this.documentFileInfosById.get(id).filename;
        }
        return '';
    }

    /**
     * Available only for requesting party AND after certification request was submitted
     */
    public removeFile(fileId: string) {
        this.dialogService
            .openConfirmDialog(
                'Wollen Sie diese Datei aus dem Zertifizierungsantrag entfernen?',
                'Abbrechen',
                'Entfernen'
            )
            .subscribe((confirmed: boolean) => {
                if (confirmed) {
                    let newFileIds = this.certificationRequest.fileIds;
                    newFileIds.splice(newFileIds.indexOf(fileId), 1);
                    this.certificationRequest.fileIds = newFileIds;
                    //Save this information --> inform backend of change of certification request
                    //LogEntry for this change
                    this.cd.detectChanges();
                }
            });
    }

    /**
     * Available only for certificating parties AND after certification request was accepted
     */
    public requestFiles() {
        this.dialogService
            .openFileRequestDialog('Nachricht', 'Abbrechen', 'Senden')
            .subscribe((requested: string) => {
                if (requested) {
                    //Text entered by User: Which files have to be added to the request?
                    //Missing: All backend-stuff & actually sending the mail.
                    //Log entry
                    this.dialogService.openDialog(
                        'Dateienanfrage versendet',
                        'Der Antragssteller wird per Mail benachrichtigt.'
                    );
                }
            });
    }

    public onCommented(logText: string) {
        this.commented.emit(logText);
    }
}
